__webpack_require__.p = "https://quantum-stage.curebay.in/";